// extracted by mini-css-extract-plugin
export default {"layout":"ProfileLayout_layout__lCS1V","header":"ProfileLayout_header__-1Kv0","navbar":"ProfileLayout_navbar__nLZY0","content":"ProfileLayout_content__GneIR"};